import NBType, { InferType } from '@netbase/nb-type'
import TimelineAnnotationSchema from './TimelineAnnotationSchema'

/**
 * @typedef {import('./TimelineAnnotationSchema').TimelineAnnotation} TimelineAnnotation
 */

/**
 * @typedef {object} TimelineAnnotationGroupSchema
 * @property {TimelineAnnotation[]} timelineAnnotations
 * @property {number} totalNotes
 */
const TimelineAnnotationGroupSchema = NBType.object().shape('TimelineAnnotationGroupSchema', {
  /* @prop */
  timelineAnnotations: NBType.array().of(TimelineAnnotationSchema),
  /* @prop */
  totalNotes: NBType.number()
  /* END */
})
export default TimelineAnnotationGroupSchema
export type TimelineAnnotationGroup = InferType<typeof TimelineAnnotationGroupSchema>
// RESERVE BELOW
